import mushroom from "pmcc-api";
import LanguageService from '@/service/LanguageService';
import { blockUi, unblockUi } from '../shared/utils';

window.requestCount = 0;

let ExtensionService = {};


ExtensionService.urlImg = window.MyConfig.hostApi + "file/thumb?id=";
ExtensionService.urlDowloadFile = window.MyConfig.hostApi + "file/download?id=";
ExtensionService.getDocumentPreviewUrl = (fileId) =>
  ExtensionService.urlDowloadFile + fileId;
ExtensionService.getPdfPreviewUrl = (fileId) =>
  ExtensionService.urlImg + fileId;
ExtensionService.getGoogleViewerUrl = (fileUrl) =>
  `https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(fileUrl)}`;
ExtensionService.getOfficeViewerUrl = (fileUrl) =>
  `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
ExtensionService.urlsTemplate = {
    ImportSalary: "/file/template/Template_Import_Luong.xlsx",
};
const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase());

ExtensionService.urlSurveyFile = window.MyConfig.surveyPath + "file/download?id=";

ExtensionService.upload = (rawDataFile, tags) => {
  blockUi();
  let body = {
    file: rawDataFile.raw, // required
    name: rawDataFile.name, // optional
    tags: Array.isArray(tags) ? tags : [tags],
    contentFormat: "BINARY"
  }
  return mushroom.$file
  .uploadAsync(body)
  .then(response => {
    unblockUi();
    return response;
  })
  .catch(error => {
    unblockUi();
    toastr.error(LanguageService.lang.c_uploadError);
    throw error;
  });
};
ExtensionService.zipFile = (arrId, name) => {
  window.open(window.MyConfig.hostApi + `file/zip?id=${arrId.join(',')}&name=${name}.zip`);
};
export default ExtensionService;
